export const DISCUSSION_NOTIFY_OPTIONS = {
  NOTIFY: true,
  DO_NOT_NOTIFY: false
}
